import { QueryModel } from '../base/query'

/**
 * @memberOf loavies.models.user
 * @constructor
 */

export class UserQueryModel extends QueryModel{
  /**
   * https://www.sharetribe.com/api-reference/integration.html#query-users
   * @param {string} [createdAtStart] Timestamp must be in ISO 8601 format.
   * @param {string} [createdAtEnd] Timestamp must be in ISO 8601 format.
   * @param {Object} [metaData] key: metaData attribute, value query syntax:https://www.sharetribe.com/api-reference/integration.html#extended-data-filtering
   * @param {Object} [privateData] key: metaData attribute, value query syntax:https://www.sharetribe.com/api-reference/integration.html#extended-data-filtering
   * @param {Object} [protectedData] key: metaData attribute, value query syntax:https://www.sharetribe.com/api-reference/integration.html#extended-data-filtering
   * @param {Object} [publicData] key: metaData attribute, value query syntax:https://www.sharetribe.com/api-reference/integration.html#extended-data-filtering
   * @param {string} [sort] https://www.sharetribe.com/api-reference/integration.html#controlling-sorting-of-users
   */
  constructor({
    createdAtStart,
    createdAtEnd,
    metaData,
    privateData,
    protectedData,
    publicData,
    sort,
  }) {
    super()

    /** @type {string} */
    this.createdAtStart = createdAtStart

    /** @type {string} */
    this.createdAtEnd = createdAtEnd

    /** @type {string} */
    this.sort = sort

    if (metaData) this.setDataFilter(metaData, 'meta_')
    if (privateData) this.setDataFilter(privateData, 'priv_')
    if (protectedData) this.setDataFilter(metaData, 'prot_')
    if (publicData) this.setDataFilter(publicData, 'pub_')
  }
}
